export default __webpack_public_path__ + "static/media/a0b2574e755e1163f8e585c0d9bd17d7.webp";